import { Component, OnInit } from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { FeathericonsModule } from '../../icons/feathericons/feathericons.module';
import { RouterLink } from '@angular/router';
import { ToggleService } from './toggle.service';
import { AuthService, User } from '../../services/auth.service';
import { TRANSPORTISTA_ROLE, transportistaLanding } from '../../guards/transportista-allowlist';

@Component({
    selector: 'app-header',
    imports: [FeathericonsModule, MatButtonModule, MatMenuModule, RouterLink, NgClass],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    providers: [
        DatePipe
    ]
})
export class HeaderComponent implements OnInit {

    constructor(
        // eslint-disable-next-line no-unused-vars
        public toggleService: ToggleService,
        // eslint-disable-next-line no-unused-vars
        private datePipe: DatePipe,
        // eslint-disable-next-line no-unused-vars
        private authService: AuthService
    ) {
        this.toggleService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.formattedDate = this.datePipe.transform(this.currentDate, 'dd MMMM yyyy');
    }

    ngOnInit(): void {
        // Suscribirse a los cambios del usuario actual
        this.authService.currentUser$.subscribe(user => {
            this.currentUser = user;
        });
    }

    // Toggle Service
    isToggled = false;
    toggle() {
        this.toggleService.toggle();
    }

    // Dark Mode
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Current Date
    currentDate: Date = new Date();
    formattedDate: any;

    // Current User
    currentUser: User | null = null;

    /**
     * Obtiene el nombre de visualización del rol
     */
    getRoleDisplayName(role: string | undefined): string {
        if (!role) return 'Usuario';
        
        const roleMap: { [key: string]: string } = {
            'admin': 'Administrador',
            'operator': 'Operador',
            'client': 'Cliente',
            'consignatario': 'Consignatario',
            'transportista': 'Transportista'
        };
        
        return roleMap[role] || role;
    }

    /** Destino del enlace de perfil: el transportista no tiene /home. */
    get homeRoute(): string {
        return this.currentUser?.roles?.includes(TRANSPORTISTA_ROLE)
            ? transportistaLanding(this.currentUser.modules)
            : '/home';
    }

    /**
     * Obtiene las iniciales del usuario (primera letra del nombre y apellido)
     */
    getUserInitials(): string {
        if (!this.currentUser) {
            return 'U';
        }
        
        // Intentar extraer iniciales del nombre completo si firstName/lastName están vacíos
        let firstName = this.currentUser.firstName?.trim();
        let lastName = this.currentUser.lastName?.trim();
        
        // Si no hay firstName/lastName, intentar extraer del email
        if (!firstName && !lastName && this.currentUser.email) {
            const emailName = this.currentUser.email.split('@')[0];
            // Si el email tiene formato como "jorge.carreno", dividir por punto
            if (emailName.includes('.')) {
                const parts = emailName.split('.');
                firstName = parts[0];
                lastName = parts[1];
            } else {
                // Usar las primeras dos letras del email
                firstName = emailName.charAt(0);
                lastName = emailName.charAt(1) || '';
            }
        }
        
        // Si aún no tenemos datos, usar fallback
        if (!firstName || !lastName) {
            return 'U';
        }
        
        const firstInitial = firstName.charAt(0).toUpperCase();
        const lastInitial = lastName.charAt(0).toUpperCase();
        
        return firstInitial + lastInitial;
    }

    /**
     * Obtiene el nombre completo del usuario
     */
    getUserFullName(): string {
        if (!this.currentUser) return 'Usuario';
        
        // Intentar obtener firstName y lastName del usuario
        let firstName = this.currentUser.firstName?.trim();
        let lastName = this.currentUser.lastName?.trim();
        
        // Si no hay firstName/lastName, intentar extraer del email
        if (!firstName && !lastName && this.currentUser.email) {
            const emailName = this.currentUser.email.split('@')[0];
            // Si el email tiene formato como "jorge.carreno", dividir por punto
            if (emailName.includes('.')) {
                const parts = emailName.split('.');
                firstName = this.capitalizeFirst(parts[0] || '');
                lastName = this.capitalizeFirst(parts[1] || '');
            } else {
                // Si no hay puntos, usar el nombre del email como firstName
                firstName = this.capitalizeFirst(emailName);
                lastName = '';
            }
        }
        
        // Construir nombre completo
        const fullName = `${firstName || ''} ${lastName || ''}`.trim();
        
        return fullName || 'Usuario';
    }
    
    /**
     * Capitaliza la primera letra de una cadena
     */
    private capitalizeFirst(str: string): string {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

}